import React, { useContext, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import PersonIcon from "@material-ui/icons/Person";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import Tooltip from "@material-ui/core/Tooltip";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components/";
import { _MainContent, _PageTitle, _PageWrapper } from "src/inar2/layout";
import { _ButtonAPI, _SecureCard, _UserDetails, _UserGroups, _UserProfile } from "src/inar2/components";
import { AlertDialogContext } from "../providers/AlertDialogProvider";

interface IRouteParam {
    ID_Utente: string;
}

const useStyles = makeStyles(({ spacing }: Theme) => ({
    btnWrapper: { marginTop: spacing(1) }
}));

export const _User: React.FC<Glob.IRouteGlobaleProps> = props => {
    const classes = useStyles();
    const { ID_Utente } = useParams<IRouteParam>();
    const { ShowDialog } = useContext(AlertDialogContext);

    const [UserData, setUserData] = useReducerOnChange<Dati.CDatiUtente>(new Dati.CDatiUtente());
    const [Groups, setGroups] = useReducerOnChange<Dati.Dictionary<boolean>>({});

    useEffect(() => {
        props.SetMenu({ ...Glob.GetMenu(), Main: "Utente", ID_MenuMain: 32 });
    }, []);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("UtentiController", Glob.Lettura) && !(Glob.AzioneAbilitata("ProprioUtente", Glob.Lettura) && UserData.ID_Utente == Glob.GetSessione().ID_Utente)) {
            location.replace("/ErroreAccesso");
            return;
        }
        GetUser();
        GetGroups();
    }, ["", ID_Utente]);

    const GetUser = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Utenti/seleziona?id_utente=${ID_Utente}`,
            OnRis: OnGetUser
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetUser = (sender: ChiamaWeb, dati: Dati.CRisAPIDatoTipiInfoUtente) => {
        dati.Dato.Password = "";
        setUserData({ Type: "Set", Value: dati.Dato.ID_Utente ? dati.Dato : new Dati.CDatiUtente() });
    };

    const GetGroups = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Utenti/GruppiAttiviUtente?id_utente=${ID_Utente}`,
            OnRis: OnGetGroups
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetGroups = (sender: ChiamaWeb, dati: Dati.CRisAPIDizionario<boolean>) => {
        setGroups({ Type: "Set", Value: dati.Dati });
    };

    const OnGroupChange = (key: string, val: boolean) => {
        setGroups({ Type: "OnChangeFromValue", Name: key, Value: val });
    };

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", `${data.ErrTesto} ${data.ErrTesti[0] ?? ""}`, "error");
        } else {
            if (UserData.ID_Utente == 0) {
                props.history.push(`/Utente/${data.ID_Chiave}`);
            }
            ShowDialog("UTENTE", Trad.TradParam("UtenteSalvatoCorrettamenteConIdUtente{1-S}", [data.ID_Chiave]), "success");
        }
    };

    const OnError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={PersonIcon} Title="Anagrafica">
                    {Glob.AzioneAbilitata("UtentiController", Glob.Scrittura) && (
                        <NavLink to="/Utente/0">
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <PersonAddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid container item xs={12} md={3} spacing={2}>
                            <Grid item xs={12}>
                                <_UserProfile Data={UserData} OnImageChange={fileName => setUserData({ Type: "OnChangeFromValue", Name: "Immagine", Value: fileName })} />
                            </Grid>
                            <Grid item xs={12}>
                                <_SecureCard UserId={UserData.ID_Utente} />
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} md={9} spacing={2}>
                            <Grid item xs={12}>
                                <_UserDetails
                                    Data={UserData}
                                    OnChange={(e, val) => setUserData({ Type: "OnChangeFromHybrid", NameEvent: val != null && val != undefined ? e : Object.assign({}, e), Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <_UserGroups Groups={Groups} OnGroupChange={OnGroupChange} />
                            </Grid>
                            <Grid container item xs={12} justify="flex-end" className={classes.btnWrapper}>
                                <_ButtonAPI
                                    Default
                                    Testo={Trad.Trad("Salva")}
                                    URL={`/api/Utenti/inar2/InAR2_Post/${UserData.ID_Utente}`}
                                    ParamCorpo={{ ...UserData, Gruppi: Groups }}
                                    OnClick={OnClickSave}
                                    OnErrore={OnError}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/User.tsx